import {useLocation, useNavigate} from 'react-router-dom';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {useEffect, useState} from 'react';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import useGetListBrandOwner from '../../../../../services/hookService/getListBrandOwner/useGetListBrandOwner';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import DotsLoading from '../../../../../components/dotsLoading';
import {sortByStatus} from '../../../../../utilities/helper/sortByStatus';
import BrandCard from '../myStoreInfo/myStoreBrands/BrandCard';
import Button from '../../../../../components/button';
import MainFooter from '../../../../../components/mazraeKit/footers/footerMain';

const MyStoreSaleAgents = () => {
  const navigate = useNavigate();
  const {data: myBrands, isLoading} = useGetListBrandOwner();
  const {state} = useLocation() as {state: ICreateBrandResponse};

  const [isOpen, setIsOpen] = useState(false);
  const [hasShown, setHasShown] = useState(false);

  useEffect(() => {
    if (state && !hasShown) {
      setIsOpen(true);
      setHasShown(true);
    }
  }, [state, hasShown]);

  const [isOpenLimit, setIsOpenLimit] = useState(false);

  const addBrandHandler = () => {
    if (!myBrands) return;

    const pendingBrands = myBrands.filter(brand => brand.status === 'pending');

    // Check if user has too many pending brands before navigation
    if (pendingBrands.length >= 1) {
      setIsOpenLimit(true);
      return;
    }

    navigate('/create-brand');
  };

  return (
    <div className="flex flex-col h-screen w-full relative">
      <div>
        <CustomHeader
          canScroll={true}
          title="عاملین فروش"
          preIcon="icon-nameArrow---Right"
          isActiveRightIcon
          onClick={() => navigate('/my-store-info')}
        />
      </div>

      <div className="p-4 mb-10 w-full overflow-y-auto flex flex-col gap-3">
        <p className="text-md text-gray-800 text-justify leading-6">
          برای مشاهده عاملین فروش محصولاتتان، برند مورد نظرتان را انتخاب کنید.
        </p>

        <div className="space-y-3 mb-20">
          {isLoading && <DotsLoading />}

          {myBrands &&
            myBrands.length > 0 &&
            myBrands
              .sort((a, b) => sortByStatus(a, b))
              .map(item => (
                <BrandCard
                  key={item.id}
                  logo={item.logo}
                  name={item.name}
                  data={item}
                  onClickNavigate={() =>
                    navigate(`/brand/${item.id}/sale-agents`)
                  }
                />
              ))}
        </div>

        {/* Created Brand Bottom Sheet ----------------------------------------- */}

        <BottomSheet
          onDismiss={() => setIsOpen(false)}
          open={isOpen}
          className="custom-bottom-sheet"
        >
          <div className="flex flex-col justify-between items-center mt-3 px-8 pb-6 relative">
            <SpanIcon
              className="icon-nameClose-remove absolute top-5 left-7 text-2xl"
              onClick={() => {
                setIsOpen(false);
                navigate(location.pathname, {replace: true, state: undefined});
              }}
            />
            <i className="icon-size2489 text-farm-shop-500 text-4xl mt-3" />
            <span className="text-lg font-Medium">ثبت برند</span>

            <p className="my-7 text-md text-justify">
              برند شما پس از بررسی توسط کارشناسان، فعال می‌شود. می‌توانید برای
              تسریع فرآیند، محصولات برندتان را اضافه کنید.
            </p>

            <button
              onClick={() =>
                navigate(state && `/create-brand/${state.id}/add-product`)
              }
              className="flex justify-center items-center rounded-lg w-full bg-farm-shop-500 text-white py-4 h-12 border-0"
            >
              افزودن محصولات برند
            </button>
          </div>
        </BottomSheet>

        {/* Brand Limit Bottom Sheet ----------------------------------------- */}

        <BottomSheet
          onDismiss={() => setIsOpenLimit(false)}
          open={isOpenLimit}
          className="custom-bottom-sheet"
        >
          <div className="flex flex-col justify-between items-center mt-3 px-8 pb-6 relative">
            <SpanIcon
              className="icon-nameClose-remove absolute top-5 left-7 text-2xl"
              onClick={() => {
                setIsOpenLimit(false);
              }}
            />
            <i className="icon-size2489 text-farm-shop-500 text-4xl mt-3" />
            <span className="text-lg font-Medium">در انتظار تایید برند</span>

            <p className="my-7 text-md text-justify">
              شما یک درخواست ثبت برند در انتظار تایید دارید. بعد از تعیین وضعیت
              آن، می‌توانید درخواست جدید ثبت کنید.
            </p>

            <button
              onClick={() => setIsOpenLimit(false)}
              className="flex justify-center items-center rounded-lg w-full bg-farm-shop-500 text-white py-4 h-12 border-0"
            >
              متوجه شدم
            </button>
          </div>
        </BottomSheet>

        <Button
          onClick={addBrandHandler}
          className="fixed left-4 right-4 bottom-20"
        >
          افزودن برند
        </Button>
      </div>

      <div className="fixed bottom-0 left-0 right-0">
        <MainFooter />
      </div>
    </div>
  );
};

export default MyStoreSaleAgents;
